// @ts-strict-ignore
import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import React from "react";
import { RouteComponentProps, Switch } from "react-router-dom";

import WalletOffersListPage from "./components/WalletOffersListPage/WalletOffersListPage";
import { walletOffersListPath } from "./urls";

export const WalletSection: React.FC<RouteComponentProps<any>> = () => {
  return (
    <>
      <WindowTitle title="Digital Wallet Offers — Kisan Basket" />
      <Switch>
        <Route exact path={walletOffersListPath} component={WalletOffersListPage} />
      </Switch>
    </>
  );
};

export default WalletSection;
